import React, { useState } from "react";
import useUserBundle from "../../userbundle/useUserBundle";
import useAdminBundle from "../useAdminBundle";
import BundleForm from "./BundleForm";
import ConfirmDeleteBundle from "./ConfirmDeleteBundle";
import { API } from "../../../../../config";

function AdminBundleManagement({ onSetActiveTab }) {
  const { bundles, isLoading, error, refetch } = useUserBundle();
  const {
    createBundle,
    createBundleStatus,
    updateBundle,
    updateBundleStatus,
    deleteBundle,
    deleteBundleStatus,
  } = useAdminBundle();
  const [showForm, setShowForm] = useState(false);
  const [editBundle, setEditBundle] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ open: false, bundle: null });
  const [deleteError, setDeleteError] = useState("");
  const [resetForm, setResetForm] = useState(false);

  const handleDelete = (bundle) => {
    setDeleteModal({ open: true, bundle });
    setDeleteError("");
  };

  const handleConfirmDelete = () => {
    setDeleteError("");
    deleteBundle(deleteModal.bundle._id, {
      onSuccess: () => {
        setDeleteModal({ open: false, bundle: null });
        refetch();
      },
      onError: (err) => {
        setDeleteError(err?.response?.data?.error || "Failed to delete bundle");
      },
    });
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Bundle Management</h2>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => {
            setEditBundle(null);
            setShowForm(true);
            onSetActiveTab("create");
          }}
        >
          + New Bundle
        </button>
      </div>
      {showForm && (
        <div className="mb-8">
          <BundleForm
            initial={editBundle}
            loading={
              createBundleStatus.isPending || updateBundleStatus.isPending
            }
            // onCancel={() => setShowForm(false)}
            onSetActiveTab={onSetActiveTab}
            resetForm={resetForm}
            onSubmit={(data) => {
              if (editBundle && editBundle._id) {
                updateBundle(
                  { bundleId: editBundle._id, bundleData: data },
                  {
                    onSuccess: () => {
                      setShowForm(false);
                      refetch();
                    },
                  }
                );
              } else {
                createBundle(data, {
                  onSuccess: () => {
                    setResetForm(true);
                    setTimeout(() => setResetForm(false), 0);
                    refetch();
                  },
                });
              }
            }}
          />
        </div>
      )}
      {isLoading ? (
        <div>Loading bundles...</div>
      ) : error ? (
        <div className="text-red-600">
          {error.message || "Failed to load bundles."}
        </div>
      ) : (
        <div className="grid gap-6">
          {bundles.map((bundle) => (
            <div
              key={bundle._id}
              className="bg-white rounded shadow p-6 flex flex-col md:flex-row md:items-center md:justify-between"
            >
              <div>
                <div className="text-lg font-semibold mb-1">{bundle.title}</div>
                <div className="text-gray-600 mb-2">{bundle.description}</div>
                <div className="text-sm text-gray-500 mb-2">
                  {new Date(bundle.startDate).toLocaleDateString()} -{" "}
                  {new Date(bundle.endDate).toLocaleDateString()}
                </div>
                <div className="flex flex-wrap gap-2 mb-2">
                  {bundle.products.map((prod, idx) => (
                    <div
                      key={prod._id || idx}
                      className="flex items-center gap-2 border rounded px-2 py-1 bg-gray-50"
                    >
                      <img
                        src={`${API}/${prod?.product?.photo}`}
                        alt={prod.product?.name}
                        className="w-8 h-8 object-cover rounded"
                      />
                      <span className="font-medium">{prod.product?.name}</span>
                      <span className="text-xs text-gray-500">
                        x{prod.quantity}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="text-sm">
                  Discount:{" "}
                  <span className="font-bold">{bundle.discountValue}</span>{" "}
                  {bundle.discountType === "percentage" ? "%" : "(fixed)"}
                </div>
              </div>
              <div className="flex gap-2 mt-4 md:mt-0">
                {/* <button
                  className="px-4 py-2 rounded bg-yellow-400 text-white"
                  onClick={() => {
                    setEditBundle(bundle);
                    setShowForm(true);
                  }}
                >
                  Edit
                </button> */}
                <button
                  className="px-4 py-2 rounded bg-red-600 text-white"
                  onClick={() => handleDelete(bundle)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      <ConfirmDeleteBundle
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, bundle: null })}
        onConfirm={handleConfirmDelete}
        bundleTitle={deleteModal.bundle?.title}
        loading={deleteBundleStatus.isPending}
        error={deleteError}
      />
    </div>
  );
}

export default AdminBundleManagement;
